import { useEffect, useState } from 'react';
import { AnalyticsWebClient } from '@atlassian/community-library';
import { getCommunityAnalyticsClient } from 'services/analytics';

interface Props {
  userId?: string;
}

export const useInitializeAnalyticsClient = ({ userId }: Props) => {
  const [analyticsClient, setAnalyticsClient] = useState<AnalyticsWebClient | undefined>(undefined);

  useEffect(() => {
    let cancelled = false;

    void (async () => {
      const analyticsClass = await getCommunityAnalyticsClient(userId || undefined);
      if (cancelled) {
        return;
      }

      const client = analyticsClass?.getAnalyticsClient?.() ?? undefined;
      setAnalyticsClient(client ?? undefined);
    })();

    return () => {
      cancelled = true;
    };
  }, [userId]);

  return { analyticsClient };
};
